import React from 'react'

const CTA = () => {
    return (
        <div className="cta">
            <a href="https://bit.ly/avinabaResume" target="_blank" rel="noopener noreferrer" className='btn'>Download CV</a>
            <a href="#contact" className='btn btn-primary'>Let's Talk</a>
        </div>
    )
}

export default CTA